import axios from 'axios'
import LocalStorage from '@/services/localStorage'
import { Component, Vue } from 'vue-property-decorator';

export default {
  login(payload: any) {
    return axios.post('/auth/login', payload)
  },
  oauthTokenLogin(payload: any) {
    let url = process.env.VUE_APP_API_ROOT_URL + '/oauth/token'
    // let url = LocalStorage.get('baseAPIURL') + '/api/oauth/token'
    
    return axios.post(url, {
      "grant_type": "password",
      "client_id": process.env.VUE_APP_OAUTH_CLIENT_ID,
      "client_secret": process.env.VUE_APP_OAUTH_CLIENT_SECRET,
      "username": payload.username,
      "password": payload.password,
      "scope": "*"
    })
  },
  oauthTokenLogin_audra_device_selection(payload: any) {
    const url = LocalStorage.get('baseAPIURL') + '/oauth/token-dvslcn'

    return axios.post(url, {
      "grant_type": "password",
      "client_id": process.env.VUE_APP_OAUTH_CLIENT_ID,
      "client_secret": process.env.VUE_APP_OAUTH_CLIENT_SECRET,
      "username": payload.username,
      "password": `${payload.password}`,
      // "tfa_required": 0,
      "scope": "*"
    })
  },

  oauthTokenLogin_audra_firsttime(payload: any) {
    return axios.post(process.env.VUE_APP_PROVISION_URL, { 
      "username": payload.username,
      "password": payload.password,
    }).then(response => {

      this.fetchedData = response.data.data.map(item => ({
        value: item.accountId + '$' + item.deviceName + '$' + item.deviceType + '$' + item.baseAPIURL + '$' + item.isActive,
        label: item.deviceName
      }));
    
      const firstItem = this.fetchedData[0].value;

      const [accountId, deviceName, deviceType, baseAPIURL, isActive] = firstItem.split('$');
      // if(isActive == 0) {
      //   const customError = {
      //     data: {
      //       error_description: "Device is inactive",
      //     },
      //     status: 403,
      //     message: "Router is inactive. To activate your router, please download the Audra App from playstore...",
      //   };
      //   return Promise.reject(customError);
      //   throw customError;
      // }

      LocalStorage.set('accountId', accountId);
      LocalStorage.set('deviceName', deviceName);
      LocalStorage.set('deviceType', deviceType);
      LocalStorage.set('baseAPIURL', baseAPIURL);
      LocalStorage.set('isActive', isActive);
      LocalStorage.set('userEmail', payload.username);
  
      axios.defaults.baseURL = LocalStorage.get('baseAPIURL') + '/api'
  
      const url = LocalStorage.get('baseAPIURL') + '/oauth/token'
  
      return axios.post(url, {
        "grant_type": "password",
        "client_id": process.env.VUE_APP_OAUTH_CLIENT_ID,
        "client_secret": process.env.VUE_APP_OAUTH_CLIENT_SECRET,
        "username": payload.username,
        "password": `${payload.password}`,
        // "tfa_required": 1,
        "scope": "*"
      })
    })

  
  },

  oauthTokenLogin_audra_otp_confirm(payload: any) {
      axios.defaults.baseURL = LocalStorage.get('baseAPIURL') + '/api'
  
      const url = LocalStorage.get('baseAPIURL') + '/oauth/verify-otp'
  
      return axios.post(url, {
        "grant_type": "password",
        "client_id": process.env.VUE_APP_OAUTH_CLIENT_ID,
        "client_secret": process.env.VUE_APP_OAUTH_CLIENT_SECRET,
        "username": payload.username,
        "password": `${payload.password}`,
        "otp": `${payload.otp_code}`,
        "scope": "*"
      })
  },

  async fetchProfile() {
    return await axios.get('/auth/get-user').then(response => {
      return response.data
    }).catch(error => {
      this.$store.dispatch("logout");
      this.$router.push("/login");
      throw (error.response)
    })
  },


  updateProfile(payload: any) {
    return axios.post('/auth/change-password', payload)
      .then(response => {
        return response.data
      }).catch(error => {
        throw (error.response)
      })
  },
  changePassword(payload: any) {
    return axios.post('/auth/change-password', payload)
      .then(response => {
        return response.data
      }).catch(error => {
        throw (error.response)
      })
  },
  resetUserPasswordByAdmin(payload: any) {
    return axios.post('/users/reset-password', payload)
      .then(response => {
        return response.data
      }).catch(error => {
        throw (error.response)
      })
  },
  async notifications(query: any = null) {
    return await axios.get('/auth/notifications', {
      params: query
    }).then(response => {
      return response.data
    }).catch(error => {
      throw (error.response)
    })
  },
  async showNotifications(id: any) {
    return await axios.get('/auth/notifications/' + id).then(response => {
      return response.data
    }).catch(error => {
      throw (error.response)
    })
  },
  destroyNotifications(id: any) {
    return axios.delete('/auth/notifications/' + id)
      .then(response => {
        return response.data
      }).catch(error => {
        throw (error.response)
      })
  },
  destroySelectedRows(payload: any) {
    return axios.put('/auth/notifications/destroySelectedRows', payload)
      .then(response => {
        return response.data
      }).catch(error => {
        throw (error.response)
      })
  }
}
